<template>
  <div id="app">
    <Head></Head>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>

import Head from '@/components/Head.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'APP',
  components: {
    Head, Footer
  },
}

</script>